import type { AccountFundingState } from 'stash/components/account-funding/types';

export const SET_ACCOUNT_FUNDING_STATE = 'SET_ACCOUNT_FUNDING_STATE';
export const CLEAR_ACCOUNT_FUNDING_STATE = 'CLEAR_ACCOUNT_FUNDING_STATE';

export const setAccountFundingState = (state: Partial<AccountFundingState>) => ({
	type: SET_ACCOUNT_FUNDING_STATE as typeof SET_ACCOUNT_FUNDING_STATE,
	payload: state,
});

export const clearAccountFundingState = () => ({
	type: CLEAR_ACCOUNT_FUNDING_STATE as typeof CLEAR_ACCOUNT_FUNDING_STATE,
});
